export enum CookieKeys {
    GEO = "geo",
}
